<template>
  <div>

  </div>
</template>

<script>
  import axios from "axios";
  import {EventBus} from "../../../main.js";

  export default {
    data() {
      return {
        lan: "jp"
      };
    },
    mounted() {
      EventBus.$on("language", data => {
        this.lan = data;
      });
    },
    created() {
      if ("lan" in localStorage) {
        this.lan = localStorage.getItem("lan");
      }
      this.varifyUser();
    },
    methods: {
      varifyUser() {
        const thisVue = this;
        var token = this.$route.params.token;
        axios
          .get("/user/verify/" + token, {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
               setTimeout(() => {
                 if (localStorage.getItem("user")) {
                    var data = JSON.parse(localStorage.getItem("user"));
                    var userId = data.id;
                    var userToken = data.user_token;
                    this.$router.push("/engineer/profile/" + userToken)
                 }
                 else{
                   this.$router.push("/global/signin")
                 }
              }, 100);
            } else {
              this.$toaster.success(
                res.data.message
              );
              setTimeout(() => {
                if (localStorage.getItem("user")) {
                    var data = JSON.parse(localStorage.getItem("user"));
                    var userId = data.id;
                    var userToken = data.user_token;
                    this.$router.push("/engineer/profile/" + userToken)
                 }
                 else{
                   this.$router.push("/global/signin")
                 }
              }, 1000);
            }
          })
          .catch(error => console.log(error));
      }
    }
  };
</script>
<style scoped>
</style>
